import { gql } from "@apollo/client";

// MISCELLANEOUS

export const GET_CITY = gql`
  query GetCity($state: String!) {
    fetchCities(
      query: { state: $state }
      pageOptions: { page: 1, limit: null }
    ) {
      items {
        _id
        name
      }
      pagination
    }
  }
`;

export const GET_STATES = gql`
  query GetStates($country: String!) {
    fetchStates(
      query: { country: $country }
      pageOptions: { page: 1, limit: 100 }
    ) {
      items {
        _id
        name
        abbreviation
        country {
          _id
          name
        }
      }
      pagination
    }
  }
`;

export const GET_COUNTRIES = gql`
  query {
    getAllCountries(
      query: { name: "United" }
      pageOptions: { page: 1, limit: 150 }
    ) {
      items {
        _id
        name
        flagUrl
        dialingCode
      }
    }
  }
`;

export const GENERAL_SEARCH = gql`
  query serach($searchText: String!) {
    searchGlobalInput(
      payload: { searchCategory: "all", searchText: $searchText }
    ) {
      source
      result {
        ... on Product {
          _id
          reference
          name
          description
          alias
          price
          # createdAt
          merchant {
            firstName
            lastName
            phone
          }
          currency {
            name
            symbol
            shortCode
          }
          country {
            _id
            name
            alias
          }
          isInStock
          isNegotiable
          quantityInStock
          images
          status
        }
        ... on UserService {
          _id
          reference
          title
          description
          price
          rateType
          status
          isNegotiable
          # createdAt
          # updatedAt
          currency {
            name
            symbol
            shortCode
          }
          city {
            name
          }
        }
      }
    }
  }
`;
// .............................

// PRODUCTS
export const GET_CATEGORIES_N_SUB = gql`
  query {
    fetchAllCategoriesAndTheirSubCategories {
      category {
        _id
        name
        isActive
        image
      }
      subCategories {
        _id
        name
        description
      }
    }
  }
`;

export const GET_CATEGORY_PRODUCT = gql`
  query fetchProduct($categoryId: String!) {
    fetchProductsByCategory(
      query: { categoryId: $categoryId }
      pageOptions: { page: 1, limit: 15 }
    ) {
      items {
        _id
        reference
        name
        description
        alias
        price
        createdAt
        rating
        merchant {
          firstName
          lastName
          phone
        }
        currency {
          name
          symbol
          shortCode
        }
        isInStock
        isNegotiable
        quantityInStock
        images
        status
      }
      pagination
    }
  }
`;

export const GET_SINGLE_PRODUCT = gql`
  query GetSingleProduct($_id: String!) {
    listAllAvailableProductsWithoutAuthentication(
      query: { _id: $_id }
      pageOptions: { page: 1, limit: 15 }
    ) {
      items {
        _id
        name
        price
        createdAt
        updatedAt
        categories {
          name
        }
        country {
          flagUrl
          name
        }
        merchant {
          firstName
          lastName
          phone

          addresses {
            addressOne
            isDefault
            state {
              name
            }
            city {
              name
            }
          }
        }

        currency {
          name
          symbol
          shortCode
        }
        isInStock
        isNegotiable
        quantityInStock
        images
        status
      }
    }
  }
`;
export const GET_SINGLE_PRODUCT_DESCRIPTION = gql`
  query GetSingleProduct($_id: String!) {
    listAllAvailableProductsWithoutAuthentication(
      query: { _id: $_id }
      pageOptions: { page: 1, limit: 15 }
    ) {
      items {
        _id
        name
        price
        description
        rating
        country {
          name
          flagUrl
        }

        pickupAddresses {
          address1
        }

        merchant {
          firstName
          lastName
          phone
          imageUrl

          addresses {
            addressOne
            isDefault
            state {
              name
            }
            city {
              name
            }
            country {
              name
            }
            zipCode
          }
        }
        comments {
          _id
          content
          rating
          createdAt
        }
        isInStock
        isNegotiable
        quantityInStock
        images
        status
      }
    }
  }
`;

export const GET_TOPSELLERS_PRODUCTS = gql`
  query {
    getMarketPlaceBestSellingProductListingForUnAuthenticatedUser {
      _id
      name
      price
      rating
      description
      country {
        flagUrl
        name
      }
      categories {
        name
      }
      merchant {
        firstName
        lastName
        phone
      }
      images
      isInStock
      isNegotiable
      quantityInStock
      images
      status
    }
  }
`;
export const GET_TOPSELLERS_PRODUCTS_AUTH = gql`
  query {
    getMarketPlaceBestSellingProductListing {
      _id
      reference
      name
      description
      alias
      price
      rating
      country {
        name
        flagUrl
      }
      categories {
        name
      }
      merchant {
        firstName
        lastName
        phone
      }
      currency {
        name
        symbol
        shortCode
      }
      isInStock
      isNegotiable
      quantityInStock
      images
      status
    }
  }
`;

export const GET_PRODUCTS = gql`
  query GetProducts($page: Float!, $limit: Float!) {
    listAllAvailableProductsWithoutAuthentication(
      query: {}
      pageOptions: { page: $page, limit: $limit }
    ) {
      items {
        _id
        rating
        reference
        name
        description
        alias
        categories {
          name
        }
        price
        createdAt
        merchant {
          firstName
          lastName
          phone
        }
        country {
          flagUrl
          name
        }
        currency {
          name
          symbol
          shortCode
        }
        isInStock
        isNegotiable
        quantityInStock
        images
        status
      }
      pagination
    }
  }
`;

// SERVICES

export const GET_SERVICES = gql`
  query {
    listAllAvailableServicesWithoutAuthentication(
      filter: {}
      pageOptions: { page: 1, limit: 100 }
    ) {
      items {
        _id
        reference
        title
        description
        price
        rateType
        status
        createdAt
        images
        updatedAt

        city {
          name
          state {
            name
            country {
              name
              currency {
                name
                symbol
                alias
              }
            }
          }
        }
      }
      pagination
    }
  }
`;
export const GET_SINGLE_SERVICE = gql`
  query GetSingleService($_id: String!) {
    listAllAvailableServicesWithoutAuthentication(
      filter: { _id: $_id }
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        reference
        title

        description
        price
        rateType
        status
        isNegotiable
        createdAt
        images
        updatedAt

        city {
          name
          state {
            name
            country {
              name
              flagUrl
              currency {
                name
                symbol
                alias
              }
            }
          }
        }
        user {
          firstName
          lastName
          imageUrl
        }
      }

      pagination
    }
  }
`;

// ..........................

// CHECKOUT N CART

export const GET_CART = gql`
  query {
    getMyShoppingCart(pageOptions: { page: 1, limit: 25 }) {
      items {
        _id
        quantity
        pricePerUnit
        totalAmount
        createdAt
        updatedAt
        product {
          _id
          name
          description
          images
        }
        session {
          _id
          currency {
            name
            shortCode
            shortCode
          }
        }
      }
      pagination
    }
  }
`;

export const GET_SERVICE_CART = gql`
  query {
    fetchMyCartServices(filter: {}, pageOptions: { page: 1, limit: 25 }) {
      items {
        _id
        reference
        offerAmount
        totalPrice
        scheduledDate
        scheduledTime
        service {
          title
          description
          images
        }

        status
        createdAt
        updatedAt
        currency {
          shortCode
          symbol
        }
      }
      pagination
    }
  }
`;

// .............................

// DASHBOARD
export const GET_PROFILE = gql`
  query {
    getProfile
  }
`;

export const GET_ALL_TRANSACTIONS = gql`
  query {
    fetchDefaultWalletHistories(
      query: {}
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        reference
        amount
        gateway
        description
        action
        type
        status
        paidAt
        updatedAt
        currency {
          symbol
          shortCode
          name
          alias
        }
      }
      pagination
    }
  }
`;

export const FETCH_DEFAULT_WALLET_HISTORIES = gql`
  query FetchDefaultWalletHistories($page: Float, $limit: Float) {
    fetchDefaultWalletHistories(
      query: {}
      pageOptions: { page: $page, limit: $limit }
    ) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        reference
        isStoreTransaction
        externalReference
        amount
        gateway
        description
        action
        type
        status
        paidAt
      }
    }
  }
`;

export const GET_ALL_ADDRESS = gql`
  query {
    fetchAllAddresses {
      firstName
      lastName
      addressOne
      addressTwo
      zipCode
      phone
      isDefault
      createdAt
      updatedAt
      _id
      city {
        _id
        name
      }
      state {
        _id
        name
      }
      country {
        _id
        name
      }
    }
  }
`;

export const GET_REFERRAL_LINK = gql`
  query GetReferralLink {
    getReferralLink {
      referralLink
    }
  }
`;

export const GET_DEFAULT_WALLET = gql`
  query GetDefaultWallet {
    getDefaultWallet {
      createdAt
      updatedAt
      _id
      spendingBalance
      earningBalance
      referralBonus
      isActive
      isDefault
    }
  }
`;

export const USE_REFERRAL_BONUS = gql`
  query UseReferralBonus {
    useReferralBonus {
      message
    }
  }
`;

export const GET_USER_REFERRALS = gql`
  query FetchAllUserReferrals {
    fetchAllUserReferrals(pageOptions: { page: 1, limit: 50 }) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        referralCode
        referrer {
          createdAt
          updatedAt
          _id
          uuid
          firstName
          lastName
          role
          imageUrl
          email
          phone
          sex
          referralCode
          otp

          verifiedAt
          profileStatus
          activityStatus
          coordinates
          registrationSource
          hasPaidMembershipFee
          hasRegistered
          hasCompletedSellerVerification
          stripeAccountId
        }
        user {
          createdAt
          updatedAt
          _id
          uuid
          firstName
          lastName
          role
          imageUrl
          email
          phone
          sex
          referralCode
          otp

          verifiedAt
          profileStatus
          activityStatus
          coordinates
          registrationSource
          hasPaidMembershipFee
          hasRegistered
          hasCompletedSellerVerification
          stripeAccountId
        }
      }
    }
  }
`;

export const GET_USER_TRANSACTIONS = gql`
  query FetchAllUserReferralTransactions {
    fetchAllUserReferralTransactions(pageOptions: { page: null, limit: null }) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        reference
        isStoreTransaction
        externalReference
        amount
        gateway
        description
        action
        type
        status
        paidAt
      }
    }
  }
`;

export const GET_ALL_SHIPPING_ADDRESS = gql`
  query FetchAllUserShippingAddress {
    fetchAllUserShippingAddress(
      query: {}
      pageOptions: { page: null, limit: null }
    ) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        firstName
        lastName
        phone
        addressOne
        addressTwo
        isDefault
        zipCode
      }
    }
  }
`;

export const GET_ALL_PUSRSES = gql`
  query {
    getWallets {
      _id
      spendingBalance
      earningBalance
      isActive
      isDefault
      currency {
        symbol
        shortCode
      }
    }
  }
`;

export const GET_ALL_PURSES = GET_ALL_PUSRSES;

export const GET_BUYER_ORDERS = gql`
  query {
    getMyOrders(query: {}, pageOptions: { page: 1, limit: 60 }) {
      items {
        _id
        reference
        pricePerUnit
        amountPaid
        quantity
        status
        shippoTransactionId
        shippoTrackingNumber
        shippoLabelUrl
        shippoProvider
        shippoServiceLevel
        createdAt
        updatedAt
        order {
          shippingOption
          currency {
            name
            alias
            shortCode
            symbol
          }
        }
        statusHistory {
          _id
          status
          createdAt
          updatedAt
        }
        product {
          _id
          name
          images
        }
      }
      pagination
    }
  }
`;

export const SERVICE_APPOINTMENT = gql`
  query {
    fetchBuyerAppointments(filter: {}, pageOptions: { page: 1, limit: 60 }) {
      items {
        _id
        reference
        offerAmount
        totalPrice
        scheduledDate
        scheduledTime
        service {
          title
          description
          images
        }
        seller {
          firstName
          lastName
          phone
          email
        }
        status
        createdAt
        updatedAt
        currency {
          shortCode
          symbol
        }
      }
      pagination
    }
  }
`;
export const SINGLE_SERVICE_APPOINTMENT = gql`
  query singleOrder($reference: String!) {
    fetchBuyerAppointments(
      filter: { reference: $reference }
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        reference
        offerAmount
        totalPrice
        scheduledDate
        scheduledTime
        service {
          title
          description
          images
        }
        seller {
          firstName
          lastName
          phone
          email
        }
        status
        createdAt
        updatedAt
        currency {
          shortCode
          symbol
        }
      }
      pagination
    }
  }
`;
export const GET_SINGLE_ORDER = gql`
  query singleOrder($reference: String!) {
    getMyOrders(
      query: { reference: $reference }
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        reference
        pricePerUnit
        amountPaid
        quantity
        status
        shippoTransactionId
        shippoTrackingNumber
        shippoLabelUrl
        shippoProvider
        shippoServiceLevel
        shippoRateAmount
        shippoRateCurrency
        createdAt
        updatedAt

        order {
          shippingOption
          currency {
            name
            alias
            shortCode
            symbol
          }
        }
        statusHistory {
          _id
          status
          createdAt
          updatedAt
        }
        product {
          price
          _id
          name
          merchant {
            addresses {
              addressOne
              isDefault
            }
          }
          images
          pickupAddresses {
            address1
          }
        }
      }
      pagination
    }
  }
`;

// ..........................

export const NOTIFICATION_TYPE = gql`
  query {
    getActiveNotificationTypes {
      _id
      title
    }
  }
`;

export const ACTIVE_NOTIFICATION = gql`
  query {
    fetchUserNotificationPreferences {
      notifications {
        _id
        title
      }
    }
  }
`;

export const GET_FAVOURITES = gql`
  query {
    getMyFavourites(filter: {}, pageOptions: { page: 1, limit: 25 }) {
      items {
        _id
        isProduct
        productOrService
        createdAt
        updatedAt
      }
      pagination
    }
  }
`;

export const GET_PRODUCT_ORIGIN = gql`
  query {
    getProductOrigins(query: {}, pageOptions: { page: 1, limit: 1000 }) {
      items {
        _id
        name
        flagUrl
      }
      pagination
    }
  }
`;

export const GET_MY_PRODUCTS = gql`
  query FetchMerchantProducts($limit: Float!) {
    fetchMerchantProducts(query: {}, pageOptions: { page: 1, limit: $limit }) {
      items {
        _id
        reference
        name
        description
        alias
        price
        currency {
          name
          symbol
          shortCode
        }
        features
        boxContent
        isInStock
        isNegotiable
        quantityInStock
        images
        createdAt
        updatedAt
        status
        specifications {
          _id
          specification
          value
        }
        subCategories {
          _id
          name
          category {
            name
            image
          }
        }
        categories {
          _id
          name
          image
        }
        pickupAddresses {
          _id
          address1
          address2
        }

        comments {
          _id
          content
          rating
          createdAt
        }
      }
      pagination
    }
  }
`;

export const GET_MY_SERVICE = gql`
  query FetchMerchantService($limit: Float!) {
    getMyServices(filter: {}, pageOptions: { page: 1, limit: $limit }) {
      items {
        _id
        reference
        title
        description
        price
        rateType
        status
        isNegotiable
        images
        createdAt
        updatedAt
        category {
          _id
          name
        }
        city {
          _id
          name
          state {
            _id
            name
            country {
              _id
              name
              currency {
                name
                symbol
                alias
              }
            }
          }
        }
      }
      pagination
    }
  }
`;

export const GET_SELLER_STATS = gql`
  query GetSellerStats {
    getSellerStats {
      totalProducts
      activeOrders
      totalRevenue
      averageRating
    }
  }
`;

export const GET_SELLER_PRODUCT_STATS = gql`
  query GetSellerProductStats {
    getSellerProductStats {
      totalProducts
      activeProducts
      lowStockProducts
      outOfStockProducts
    }
  }
`;

export const GET_SELLER_PRODUCTS = gql`
  query GetSellerProducts {
    getSellerProducts(query: {}, pageOptions: { page: null, limit: null }) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        reference
        name
        alias
        description
        reasonForRejection
        isNegotiable
        isDeleted
        price
        weight
        quantityInStock
        isInStock
        images
        features
        boxContent
        rating
        videoUrls
        tags
        deliveryProcessingTime
        lowStockAlert
        status
        deletedAt
        totalViews
        isFavourite
        categories {
          createdAt
          updatedAt
          _id
          name
          image
          description
          isActive
          isForService
        }
      }
    }
  }
`;

export const FETCH_PRODUCT_BY_ID = gql`
  query FetchProductById($productId: String!) {
    fetchProductById(query: { productId: $productId }) {
      createdAt
      updatedAt
      _id
      reference
      name
      alias
      description
      reasonForRejection
      isNegotiable
      isDeleted
      price
      weight
      quantityInStock
      isInStock
      images
      features
      boxContent
      rating
      videoUrls
      tags
      deliveryProcessingTime
      lowStockAlert
      status
      deletedAt
      totalViews
      isFavourite
      categories {
        _id
        name
      }
    }
  }
`;

export const GET_PRODUCTS_BY_STATUS = gql`
  query GetProductsByStatus($status: String!, $page: Float, $limit: Float) {
    getProductsByStatus(
      payload: { status: $status }
      pageOptions: { page: $page, limit: $limit }
    ) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        reference
        name
        alias
        description
        reasonForRejection
        isNegotiable
        isDeleted
        price
        weight
        quantityInStock
        isInStock
        images
        features
        boxContent
        rating
        videoUrls
        tags
        deliveryProcessingTime
        lowStockAlert
        status
        deletedAt
        totalViews
        isFavourite
        categories {
          _id
          name
        }
      }
    }
  }
`;

export const GET_ORDER_STATS = gql`
  query GetOrderStats {
    getOrderStats {
      newOrders
      processing
      outForDelivery
      delivered
    }
  }
`;

export const GET_SELLER_ORDERS_LIST = gql`
  query GetSellerOrders($page: Float, $limit: Float) {
    getSellerOrders(query: {}, pageOptions: { page: $page, limit: $limit }) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        reference
        pricePerUnit
        amountPaid
        sellerAmount
        quantity
        weight
        status
        shippoShipmentId
        shippoRateId
        shippoTransactionId
        shippoTrackingNumber
        shippoLabelUrl
        shippoProvider
        shippoServiceLevel
        shippoRateAmount
        shippoRateCurrency
      }
    }
  }
`;

export const GET_SELLER_ORDER_DETAIL = gql`
  query GetSellerOrderDetail($orderItemId: String!) {
    getSellerOrderDetail(payload: { orderItemId: $orderItemId }) {
      createdAt
      updatedAt
      _id
      reference
      pricePerUnit
      amountPaid
      sellerAmount
      quantity
      weight
      status
      shippoShipmentId
      shippoRateId
      shippoTransactionId
      shippoTrackingNumber
      shippoLabelUrl
      shippoProvider
      shippoServiceLevel
      shippoRateAmount
      shippoRateCurrency
      product {
        _id
        name
        images
      }
    }
  }
`;

export const GET_SELLER_TRENDS_ANALYTICS = gql`
  query GetSellerTrendsAnalytics {
    getSellerTrendsAnalytics {
      orders {
        month
        total
      }
      revenue {
        month
        total
      }
    }
  }
`;

export const GET_SELLER_ORDER_STATUS_COUNTS = gql`
  query GetSellerOrderStatusCounts {
    getSellerOrderStatusCounts {
      status
      count
    }
  }
`;

export const GET_SELLER_CUSTOMERS = gql`
  query GetSellerCustomers($page: Float, $limit: Float) {
    getSellerCustomers(pageOptions: { page: $page, limit: $limit }) {
      totalDocs
      limit
      page
      totalPages
      hasNextPage
      hasPrevPage
      docs {
        customerId
        customerName
        totalOrders
        totalSpent
        lastOrderDate
      }
    }
  }
`;

export const GET_CUSTOMER_ORDER_HISTORY = gql`
  query GetCustomerOrderHistory(
    $customerId: String!
    $page: Float
    $limit: Float
  ) {
    getCustomerOrderHistory(
      payload: { customerId: $customerId }
      pageOptions: { page: $page, limit: $limit }
    ) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        reference
        pricePerUnit
        amountPaid
        sellerAmount
        quantity
        weight
        status
        shippoShipmentId
        shippoRateId
        shippoTransactionId
        shippoTrackingNumber
        shippoLabelUrl
        shippoProvider
        shippoServiceLevel
        shippoRateAmount
        shippoRateCurrency
      }
    }
  }
`;

export const GET_SELLER_ORDERS_WITH_CUSTOMER = gql`
  query GetSellerOrdersWithCustomer {
    getSellerOrdersWithCustomer(
      query: {}
      pageOptions: { limit: null, page: null }
    ) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        reference
        pricePerUnit
        amountPaid
        sellerAmount
        quantity
        weight
        status
        shippoShipmentId
        shippoRateId
        shippoTransactionId
        shippoTrackingNumber
        shippoLabelUrl
        shippoProvider
        shippoServiceLevel
        shippoRateAmount
        shippoRateCurrency
        product {
          name
          reference
          images
        }
        buyer {
          firstName
          lastName
        }
        order {
          currency {
            symbol
            shortCode
          }
        }
      }
    }
  }
`;

export const GET_SELLER_TOP_PRODUCTS_CURRENT_MONTH = gql`
  query GetSellerTopProductsCurrentMonth {
    getSellerTopProductsCurrentMonth {
      totalAmountSold
      quantitySold
      product {
        createdAt
        updatedAt
        _id
        reference
        name
        alias
        description
        reasonForRejection
        isNegotiable
        isDeleted
        price
        weight
        quantityInStock
        isInStock
        images
        features
        boxContent
        rating
        videoUrls
        tags
        deliveryProcessingTime
        lowStockAlert
        status
        deletedAt
        totalViews
        isFavourite
      }
    }
  }
`;

export const GET_MY_ORDERS = gql`
  query {
    getSellerOrders(query: {}, pageOptions: { page: 1, limit: 25 }) {
      items {
        _id
        reference
        pricePerUnit
        amountPaid
        quantity
        status
        shippoTransactionId
        shippoTrackingNumber
        shippoLabelUrl
        shippoProvider
        shippoServiceLevel
        createdAt
        updatedAt
        dispute {
          reason
          description
          files
        }
        cancellation {
          reason
          description
        }
        order {
          reference
          currency {
            name
            alias
            shortCode
            symbol
          }
        }
        statusHistory {
          _id
          status
          createdAt
          updatedAt
        }
        product {
          _id
          name
          images
        }
        buyer {
          firstName
          lastName
          imageUrl
        }
      }

      pagination
    }
  }
`;

export const GET_SINGLE_MY_ORDER = gql`
  query getSingleOrders($id: String!) {
    getSellerOrders(query: { _id: $id }, pageOptions: { page: 1, limit: 25 }) {
      items {
        _id
        reference
        pricePerUnit
        amountPaid
        quantity
        status
        shippoTrackingNumber
        shippoLabelUrl
        shippoProvider
        shippoServiceLevel
        shippoRateAmount
        shippoRateCurrency
        createdAt
        updatedAt
        dispute {
          reason
          description
          files
        }
        cancellation {
          reason
          description
        }
        order {
          reference
          shippingOption
          currency {
            name
            alias
            shortCode
            symbol
          }
        }
        statusHistory {
          _id
          status
          createdAt
          updatedAt
        }
        product {
          _id
          name
          images
        }
      }
      pagination
    }
  }
`;

export const GET_MY_APPOINTMENT = gql`
  query {
    fetchSellerAppointments(filter: {}, pageOptions: { page: 1, limit: 25 }) {
      items {
        _id
        reference
        offerAmount
        totalPrice
        scheduledDate
        scheduledTime
        service {
          title
          description
        }
        seller {
          firstName
          lastName
          phone
          email
        }
        status
        createdAt
        updatedAt
        currency {
          shortCode
          symbol
        }
      }
      pagination
    }
  }
`;

export const GET_UPCOMING_APPOINTMENTS = gql`
  query FetchSellerUpcomingAppointments {
    fetchSellerUpcomingAppointments(
      filter: {}
      pageOptions: { page: 1, limit: 100 }
    ) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        reference
        offerAmount
        totalPrice
        scheduledDate
        scheduledTime
        status
        service {
          createdAt
          updatedAt
          _id
          reference
          images
          title
          description
          price
          isNegotiable
          rateType
          status
        }
        seller {
          createdAt
          updatedAt
          _id
          uuid
          firstName
          lastName
          role
          imageUrl
          email
          phone
          sex
          dateOfBirth
          referralCode
          otp
          verifiedAt
          profileStatus
          activityStatus
          coordinates
          registrationSource
          hasPaidMembershipFee
          hasRegistered
          hasCompletedSellerVerification
          stripeAccountId
        }
        buyer {
          createdAt
          updatedAt
          _id
          uuid
          firstName
          lastName
          role
          imageUrl
          email
          phone
          sex
          dateOfBirth
          referralCode
          otp
          verifiedAt
          profileStatus
          activityStatus
          coordinates
          registrationSource
          hasPaidMembershipFee
          hasRegistered
          hasCompletedSellerVerification
          stripeAccountId
        }
        statusHistory {
          _id
          status
          createdAt
          updatedAt
        }
        charges {
          createdAt
          updatedAt
          _id
          name
          description
          chargeType
          chargeValue
          currency
          activityType
          isActive
        }
        currency {
          createdAt
          updatedAt
          _id
          name
          alias
          shortCode
          symbol
        }
      }
    }
  }
`;

export const GET_REQUESTS_FOR_APPOINTMENTS = gql`
  query FetchSellerAppointmentRequests {
    fetchSellerAppointmentRequests(
      filter: {}
      pageOptions: { page: 1, limit: 100 }
    ) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        reference
        offerAmount
        totalPrice
        scheduledDate
        scheduledTime
        status
        service {
          createdAt
          updatedAt
          _id
          reference
          images
          title
          description
          price
          isNegotiable
          rateType
          status
        }
        seller {
          createdAt
          updatedAt
          _id
          uuid
          firstName
          lastName
          role
          imageUrl
          email
          phone
          sex
          dateOfBirth
          referralCode
          otp
          verifiedAt
          profileStatus
          activityStatus
          coordinates
          registrationSource
          hasPaidMembershipFee
          hasRegistered
          hasCompletedSellerVerification
          stripeAccountId
        }
        buyer {
          createdAt
          updatedAt
          _id
          uuid
          firstName
          lastName
          role
          imageUrl
          email
          phone
          sex
          dateOfBirth
          referralCode
          ot
          verifiedAt
          profileStatus
          activityStatus
          coordinates
          registrationSource
          hasPaidMembershipFee
          hasRegistered
          hasCompletedSellerVerification
          stripeAccountId
        }
        statusHistory {
          _id
          status
          createdAt
          updatedAt
        }
        charges {
          createdAt
          updatedAt
          _id
          name
          description
          chargeType
          chargeValue
          currency
          activityType
          isActive
        }
        currency {
          createdAt
          updatedAt
          _id
          name
          alias
          shortCode
          symbol
        }
      }
    }
  }
`;

export const GET_HISTORY_FOR_APPOINTMENTS = gql`
  query FetchSellerAppointmentHistory {
    fetchSellerAppointmentHistory(
      filter: {}
      pageOptions: { page: 1, limit: 100 }
    ) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        reference
        offerAmount
        totalPrice
        scheduledDate
        scheduledTime
        status
        service {
          createdAt
          updatedAt
          _id
          reference
          images
          title
          description
          price
          isNegotiable
          rateType
          status
        }
        seller {
          createdAt
          updatedAt
          _id
          uuid
          firstName
          lastName
          role
          imageUrl
          email
          phone
          sex
          dateOfBirth
          referralCode
          otp
          verifiedAt
          profileStatus
          activityStatus
          coordinates
          registrationSource
          hasPaidMembershipFee
          hasRegistered
          hasCompletedSellerVerification
          stripeAccountId
        }
        buyer {
          createdAt
          updatedAt
          _id
          uuid
          firstName
          lastName
          role
          imageUrl
          email
          phone
          sex
          dateOfBirth
          referralCode
          otp
          verifiedAt
          profileStatus
          activityStatus
          coordinates
          registrationSource
          hasPaidMembershipFee
          hasRegistered
          hasCompletedSellerVerification
          stripeAccountId
        }
        statusHistory {
          _id
          status
          createdAt
          updatedAt
        }
        charges {
          createdAt
          updatedAt
          _id
          name
          description
          chargeType
          chargeValue
          currency
          activityType
          isActive
        }
        currency {
          createdAt
          updatedAt
          _id
          name
          alias
          shortCode
          symbol
        }
      }
    }
  }
`;

export const GET_SINGLE_APPOINTMENT = gql`
  query getSingleOrders($id: String!) {
    fetchSellerAppointments(
      filter: { _id: $id }
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        reference
        offerAmount
        totalPrice
        scheduledDate
        scheduledTime
        service {
          title
          description
        }
        seller {
          firstName
          lastName
          phone
          email
        }
        status
        createdAt
        updatedAt
        currency {
          shortCode
          symbol
        }
      }
      pagination
    }
  }
`;

export const GET_MY_STORE_BALANCE = gql`
  query user($userId: String!) {
    getUserStoreBalanceInformationByUserId(payload: { userId: $userId }) {
      totalEarned
      totalWithdrawn
      balance
    }
  }
`;

export const GET_SELL_AMOUNT = gql`
  query {
    getSellerBills {
      amountToPay
      currency {
        shortCode
        symbol
      }
    }
  }
`;

export const GET_MY_BANKS = gql`
  query {
    allMyBanks {
      _id
      accountName
      accountNumber
      routingNumber
      bankName
      createdAt
      updatedAt
    }
  }
`;

export const GET_PRODUCT_ORIGINS = gql`
  query {
    searchProductOrigins(
      filter: { textToSearch: "" }
      pageOptions: { page: 1, limit: 261 }
    ) {
      items {
        name
        _id
        flagUrl
        productCount
      }
    }
  }
`;

export const GET_PRODUCT_ORIGIN_ID = gql`
  query FetchProductsByCountry($countryId: String!) {
    fetchProductsByCountry(
      query: { countryId: $countryId }
      pageOptions: { page: null, limit: null }
    ) {
      pagination
      items {
        updatedAt
        _id
        reference
        name
        alias
        description
        isNegotiable
        price
        weight
        quantityInStock
        isInStock
        images
        features
        boxContent
        rating
        status
        deletedAt
        totalViews

        subCategories {
          createdAt
          updatedAt
          _id
          name
          description
          isActive
        }
        currency {
          createdAt
          updatedAt
          _id
          name
          alias
          shortCode
          symbol
        }
        country {
          createdAt
          updatedAt
          _id
          name
          alias
          flagUrl
          productCount
        }

        specifications {
          _id
          specification
          value
        }
        pickupAddresses {
          _id
          address1
          address2
          createdAt
        }
        stockHistory {
          _id
          initialQuantity
          quantity
          method
          stockDeliveredAt
          createdAt
        }
        comments {
          _id
          content
          rating
          createdAt
        }
      }
    }
  }
`;

export const GET_NOTIFICATION = gql`
  query GetAllNotifications {
    getAllNotifications(query: {}, pageOptions: { page: null, limit: null }) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        event
        title
        message
        icon
        metaData
        isRead
      }
    }
  }
`;

export const GET_MY_CART_SUMMARY = gql`
  query GetMyCartSummary($payload: GetMyCartSummaryInput!) {
    getMyCartSummary(payload: $payload) {
      itemPrice
      serviceFee
      taxFee
      shippingFee
      subTotal
      total
    }
  }
`;

export const GET_TRENDING_PRODUCTS = gql`
  query GetTrendingProducts {
    getTrendingProducts {
      createdAt
      updatedAt
      _id
      reference
      name
      alias
      description
      reasonForRejection
      isNegotiable
      isDeleted
      price
      weight
      quantityInStock
      isInStock
      images
      features
      boxContent
      rating
      status
      deletedAt
      totalViews
      isFavourite
      categories {
        createdAt
        updatedAt
        _id
        name
        image
        description
        isActive
        isForService
      }
      country {
        createdAt
        updatedAt
        _id
        name
        alias
        flagUrl
        productCount
      }
    }
  }
`;

export const GET_POPULAR_CATEGORIES = gql`
  query GetPopularCategories {
    getPopularCategories {
      createdAt
      updatedAt
      _id
      name
      image
      description
      isActive
      isForService
    }
  }
`;

export const GET_RANDOM_PRODUCTS = gql`
  query FetchRandomProducts {
    fetchRandomProducts {
      createdAt
      updatedAt
      _id
      reference
      name
      alias
      description
      reasonForRejection
      isNegotiable
      isDeleted
      price
      weight
      quantityInStock
      isInStock
      images
      features
      boxContent
      rating
      status
      deletedAt
      totalViews
      isFavourite
    }
  }
`;

export const GET_CONTINENTAL_FINDS = gql`
  query FetchContinents {
    fetchContinents {
      name
      slug
      imageUrl
    }
  }
`;

export const GET_HAND_PICKED = gql`
  query FetchHandPickedProducts {
    fetchHandPickedProducts {
      createdAt
      updatedAt
      _id
      reference
      name
      alias
      description
      reasonForRejection
      isNegotiable
      isDeleted
      price
      weight
      quantityInStock
      isInStock
      images
      features
      boxContent
      rating
      status
      deletedAt
      totalViews
      isFavourite
    }
  }
`;

export const SINGLE_CONTINENTAL_PRODUCTS = gql`
  query GetProductsByContinent($slug:String!) {
    getProductsByContinent(
      query: { slug: $slug }
      pageOptions: { limit: 48, page: 1 }
    ) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        reference
        name
        alias
        description
        reasonForRejection
        isNegotiable
        isDeleted
        price
        weight
        quantityInStock
        isInStock
        images
        features
        boxContent
        rating
        status
        deletedAt
        totalViews
        isFavourite
        categories {
          name
        }
        country {
          flagUrl
          name
        }
        merchant {
          firstName
          lastName
        }
      }
    }
  }
`;

export const GET_BANNERS = gql`
  query FetchBanners {
    fetchBanners(query: {}) {
      createdAt
      updatedAt
      _id
      type
      imageUrl
      description
      route
    }
  }
`;

export const FETCH_STORES = gql`
  query FetchStores {
    fetchStores(pageOptions: { page: null, limit: null })
  }
`;

export const GET_BLOGS = gql`
query FetchBlogs {
    fetchBlogs(
        query: { }
        pageOptions: { page: null, limit: null }
    ) {
        pagination
        items {
            createdAt
            updatedAt
            _id
            title
            slug
            imageUrl
            content
            category
            status
            isDeleted
            description
        }
    }
}
`;

export const GET_SINGLE_BLOG = gql`
query FindBlogBySlug ($slug:String!) {
    findBlogBySlug(slug: $slug) {
        createdAt
        updatedAt
        _id
        title
        slug
        imageUrl
        content
        description
        category
        status
        isDeleted
    }
}
`

export const GET_SELLERS_PLANS = gql`
query FetchAllPlans {
    fetchAllPlans {
        createdAt
        updatedAt
        _id
        name
        code
        price
        currency
        billingCycle
        productLimit
        features
        isRecommended
        isActive
    }
}
`

export const GET_CURRENT_SUBSCRIPTION_PLAN = gql`
query GetCurrentSubscriptionPlan {
    getCurrentSubscriptionPlan {
        plan {
            createdAt
            updatedAt
            _id
            name
            code
            price
            currency
            billingCycle
            productLimit
            features
            isRecommended
            isActive
        }
        subscription {
            createdAt
            updatedAt
            _id
            status
            startDate
            endDate
            autoRenew
        }
    }
}
`
